import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalConfig } from '../../models/modal.config';

@Component({
  selector: 'app-modal',
  templateUrl: './app-modal.component.html',
  styleUrls: ['./app-modal.component.scss']
})
export class AppModalComponent implements OnInit {
  @Input() public modalConfig: ModalConfig;
  @ViewChild('modal') private modalContent: TemplateRef<AppModalComponent>;
  private modalRef: NgbModalRef;

  constructor(private modalService: NgbModal) { }

  ngOnInit(): void { }

  open(): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      this.modalRef = this.modalService.open(this.modalContent, {
        backdrop: this.modalConfig.ignoreBackdropClick,
        size: this.modalConfig.size ? this.modalConfig.size : 'lg',
        centered: true,
        scrollable: this.modalConfig.scrollable
      })
      this.modalRef.result.then(resolve, resolve)
    })
  }

  async close(): Promise<void> {

    const result = this.modalConfig.onClose === undefined || (await this.modalConfig.onClose());
    //this.modalRef.close(result)
    if (result) {
      this.modalRef.close(result)
    }
  }

  async dismiss(): Promise<void> {
    if (this.modalConfig.shouldDismiss === undefined || (await this.modalConfig.shouldDismiss())) {
      const result = this.modalConfig.onDismiss === undefined || (await this.modalConfig.onDismiss())
      this.modalRef.dismiss(result)
    }
  }
}
